<template>
    <div v-if="show" class="aut-homepage-modal-overlay" @click.self="closeModal">
        <div class="aut-homepage-modal-content">
            <button class="aut-homepage-modal-close" @click="closeModal">&times;</button>
            <div v-if="banner" class="aut-homepage-modal-banner">
                <img :src="banner" alt="Banner">
            </div>
            <div class="aut-homepage-modal-body">
                <div v-if="text" v-html="text" class="aut-homepage-modal-text"></div>
                <div v-if="linkUrl && linkTitle" class="aut-homepage-modal-link">
                    <a :href="linkUrl" target="_blank" @click="closeModal" class="btn btn-primary">{{ linkTitle }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            show: false,
            banner: '',
            text: '',
            linkTitle: '',
            linkUrl: '',
            displayInterval: 24,
            storageKey: 'aut_homepage_modal_last_shown'
        };
    },
    mounted() {
        if (typeof drupalSettings !== 'undefined' && drupalSettings.autohopper_homepage_modal) {
            const settings = drupalSettings.autohopper_homepage_modal;
            this.banner = settings.banner;
            this.text = settings.text;
            this.linkTitle = settings.link_title;
            this.linkUrl = settings.link_url;
            this.displayInterval = settings.display_interval || 24;

            this.checkDisplay();
        }
    },
    methods: {
        checkDisplay() {
            const lastShown = localStorage.getItem(this.storageKey);
            const now = new Date().getTime();
            const intervalMs = this.displayInterval * 60 * 60 * 1000;

            if (!lastShown || (now - lastShown) > intervalMs) {
                this.show = true;
            }
        },
        closeModal() {
            this.show = false;
            localStorage.setItem(this.storageKey, new Date().getTime());
        }
    }
};
</script>

<style scoped>
.aut-homepage-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}
.aut-homepage-modal-content {
    background: #fff;
    padding: 10px;
    border-radius: 8px;
    position: relative;
    max-width: 500px;
    width: 90%;
    box-shadow: 0 4px 15px rgba(0,0,0,0.2);
}
.aut-homepage-modal-body {
    padding: 10px;
}
.aut-homepage-modal-close {
    position: absolute;
    top: -10px;
    right: -10px;
    background: #fff;
    border-radius: 50%;
    border: none;
    font-size: 34px;
    cursor: pointer;
    width: 30px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    text-decoration: none;
    color: #bbb;
}
.aut-homepage-modal-banner img {
    width: 100%;
    height: auto;
    border-radius: 4px;
    margin-bottom: 15px;
}
.aut-homepage-modal-text {
    margin-bottom: 20px;
}
.aut-homepage-modal-link {
    text-align: center;
}
</style>
